export default __webpack_public_path__ + "static/media/cu.ad1a7513.jpg";